import Vue from 'vue'
import VueI18n from 'vue-i18n'
import * as Moment from 'moment'
import { Validator } from 'vee-validate'
import { setStorage } from '@/service/localStorage.service'
import messages from '@/language/Locales/en-US'
import config from '@/config'

Vue.use(VueI18n)

/**
 * our default language that is preloaded 
 */
const languages = ['en-US']
const I18N = new VueI18n({
  messages,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  silentTranslationWarn: true
})

/**
 * Set all modules useful langage.
 * 
 * @param {String} input
 */
const setLanguage = (input: string): string => {
  setStorage(config.APP_LANG, input)

  I18N.locale = input
  Moment.locale(input)
  Validator.localize(input)
  document.documentElement.lang = input

  return input
}

/**
 * @param {String} lang
 */
const loadLanguageAsync = (input: string): any => {
  if (I18N.locale !== input) {
    if (!languages.includes(input)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/language/Locales/${input}`)
        .then(msgs => {
          I18N.setLocaleMessage(input, msgs.default[input])

          // Localize takes the locale object as the second argument (optional) and merges it.
          Validator.localize(input, {
            [name]: (input as any),
            messages: msgs.default[input].errors
          })
          
          languages.push(input)
          return setLanguage(input)
        })
    }
    return Promise.resolve(setLanguage(input))
  }
  return Promise.resolve(input)
}

export default I18N
export {
  loadLanguageAsync as t
}